import { useState } from 'react';

const ZONAS = [
  'Machalí', 'Rancagua', 'Sewell',
  'Santiago Centro', 'Pudahuel', 'La Florida',
  'Maipú', 'Puente Alto', 'San Bernardo',
];

export default function StepDatosArbitro({ datos, onNext }) {
  const [form, setForm] = useState({
    nombre:      datos.nombre      || '',
    email:       datos.email       || '',
    celular:     datos.celular     || '',
    password:    datos.password    || '',
    zona:        datos.zona        || '',
    experiencia: datos.experiencia || '',
  });
  const [errores, setErrores] = useState({});

  const actualizar = (campo, valor) => {
    setForm(prev => ({ ...prev, [campo]: valor }));
    setErrores(prev => ({ ...prev, [campo]: '' }));
  };

  const validar = () => {
    const e = {};
    if (!form.nombre.trim())       e.nombre      = 'Ingresa tu nombre';
    if (!form.email.includes('@')) e.email       = 'Email inválido';
    if (form.celular.length < 8)   e.celular     = 'Celular inválido';
    if (form.password.length < 6)  e.password    = 'Mínimo 6 caracteres';
    if (!form.zona)                e.zona        = 'Selecciona tu zona';
    return e;
  };

  const handleNext = () => {
    const e = validar();
    if (Object.keys(e).length > 0) { setErrores(e); return; }
    onNext(form);
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Tus datos personales</h2>
      <p style={styles.sub}>
        Crea tu cuenta de árbitro en TuRival. Los equipos
        podrán encontrarte y contratarte para sus partidos.
      </p>

      {[
        { campo: 'nombre',   label: 'Nombre completo',  placeholder: 'Roberto Fuentes',     type: 'text'     },
        { campo: 'email',    label: 'Email',             placeholder: 'roberto@email.cl',    type: 'email'    },
        { campo: 'celular',  label: 'Celular',           placeholder: '+56 9 1234 5678',     type: 'text'     },
        { campo: 'password', label: 'Contraseña',        placeholder: 'Mínimo 6 caracteres', type: 'password' },
      ].map(({ campo, label, placeholder, type }) => (
        <div key={campo} style={styles.campo}>
          <label style={styles.label}>{label}</label>
          <input
            type={type}
            value={form[campo]}
            onChange={e => actualizar(campo, e.target.value)}
            placeholder={placeholder}
            style={{
              ...styles.input,
              borderColor: errores[campo] ? '#EF4444' : '#E8ECF4',
            }}
          />
          {errores[campo] && (
            <span style={styles.error}>{errores[campo]}</span>
          )}
        </div>
      ))}

      <div style={styles.campo}>
        <label style={styles.label}>Zona donde arbitras</label>
        <select
          value={form.zona}
          onChange={e => actualizar('zona', e.target.value)}
          style={{
            ...styles.select,
            borderColor: errores.zona ? '#EF4444' : '#E8ECF4',
          }}
        >
          <option value="">Selecciona tu zona</option>
          {ZONAS.map(z => <option key={z}>{z}</option>)}
        </select>
        {errores.zona && <span style={styles.error}>{errores.zona}</span>}
      </div>

      <div style={styles.campo}>
        <label style={styles.label}>Años de experiencia (opcional)</label>
        <input
          type="number"
          value={form.experiencia}
          onChange={e => actualizar('experiencia', e.target.value)}
          placeholder="Ej: 5"
          style={styles.input}
          min="0" max="50"
        />
      </div>

      <button style={styles.btnNext} onClick={handleNext}>
        Siguiente →
      </button>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5,
  },
  campo: { marginBottom: 16 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
  },
  select: {
    width: '100%', padding: '11px 14px',
    border: '1.5px solid #E8ECF4', borderRadius: 10,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    background: 'white',
  },
  error: {
    display: 'block', fontSize: 11,
    color: '#EF4444', marginTop: 4,
    fontFamily: "'Barlow', sans-serif",
  },
  btnNext: {
    width: '100%', padding: '13px',
    background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer', marginTop: 8,
  },
};